import { VdpSimilars } from '../components/vdp/similars.vue';
Vue.component('vdp-similars', VdpSimilars);